const cindyGameDialogDataset = {
  friendName: "Cindy",
  dialogTable: [

    {dialogNbr: 1, title: "Meet Cindy",
     text: "Hi, I’m Cindy. My mom mentioned you just moved in. She said we might have a lot in common.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Nice to meet you, Cindy!", moodPoints: 2, rltnPoints: 2},
       {rspText: "Maybe later, I’m a bit busy.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 2, title: "Job Intro",
     text: "I’m an accountant. I like things balanced and tidy. Do you like working with numbers?",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "You bet, I’ve always enjoyed math.", moodPoints: 1, rltnPoints: 1},
       {rspText: "No, numbers just aren’t my thing.", moodPoints: -1, rltnPoints: 0}
     ]},

    {dialogNbr: 3, title: "College Story",
     text: "My parents insisted I go to college. I wasn’t excited at first, but it turned out to be the right move.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Glad to hear it worked out well.", moodPoints: 1, rltnPoints: 1},
       {rspText: "I’m really not a big fan of college.", moodPoints: 0, rltnPoints: -1}
     ]},

    {dialogNbr: 4, title: "Money History",
     text: "My parents made good money but still argued about it constantly. I learned early to save and plan ahead.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "That definitely makes sense to me.", moodPoints: 1, rltnPoints: 1},
       {rspText: "I think you might be overthinking it.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 5, title: "College Advice",
     text: "You seem smart. Ever think about going to college to boost your options?",
     conditionList: ["no-college"], type: "inPerson",
     responses: [
       {rspText: "Yeah, but I really am not interested.", moodPoints: -1, rltnPoints: -1},
       {rspText: "I think it could be a good idea.", moodPoints: 1, rltnPoints: 1}
     ]},

    {dialogNbr: 6, title: "College Check-In",
     text: "You mentioned you went to college. Are you glad you did?",
     conditionList: ["2-years-college"], type: "inPerson",
     responses: [
       {rspText: "No, I don’t think it helped me much.", moodPoints: -1, rltnPoints: -1},
       {rspText: "Yes, it made a big difference for me.", moodPoints: 1, rltnPoints: 1}
     ]},

    {dialogNbr: 7, title: "College Check-In",
     text: "You went to college, right? Do you feel it paid off?",
     conditionList: ["4-years-college"], type: "inPerson",
     responses: [
       {rspText: "Not really, it didn’t help much.", moodPoints: -1, rltnPoints: -1},
       {rspText: "Definitely, it was totally worth it.", moodPoints: 1, rltnPoints: 1}
     ]},

    {dialogNbr: 8, title: "Monthly Budget",
     text: "Do you track how much you earn and spend each month?",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Yes, I always track my budget carefully.", moodPoints: 2, rltnPoints: 2},
       {rspText: "Seems like a waste of my time.", moodPoints: 1, rltnPoints: -2}
     ]},

    {dialogNbr: 9, title: "401k Setup",
     text: "I set up a 401(k) years ago. Even small monthly deposits add up. Retirement sneaks up fast.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "That’s a very smart long-term plan.", moodPoints: 1, rltnPoints: 1},
       {rspText: "If you say so, I’ll try it.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 10, title: "Side Hustle",
     text: "A small side gig helped me save faster. Ever consider one?",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Good idea, I could really use extra cash.", moodPoints: 1, rltnPoints: 1},
       {rspText: "No thanks, I don’t need extra work.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 11, title: "Credit Cards",
     text: "I always pay my credit card in full. Interest rates can be 20% or more. It adds up fast.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Good tip, I should do the same.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Okay… I guess I’ll consider that.", moodPoints: -1, rltnPoints: 0}
     ]},

    {dialogNbr: 12, title: "Work Win",
     text: "One of our accounts was way off. I tracked down the error. My boss was thrilled!",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Nice work! That’s very impressive indeed.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Math… nope, that’s not for me.", moodPoints: -1, rltnPoints: 0}
     ]},

    {dialogNbr: 13, title: "Life Lesson",
     text: "People buy things they don’t need with money they don’t have. I try to stay mindful.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "True, that really makes a lot of sense.", moodPoints: 1, rltnPoints: 1},
       {rspText: "I don’t think that’s really true, honestly.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 14, title: "Saving for Home",
     text: "I’m saving for a house. A 20% down payment avoids extra fees. Thinking about owning someday?",
     conditionList: ["homeType-apartment"], type: "inPerson",
     responses: [
       {rspText: "Not yet, I’m still saving slowly.", moodPoints: -1, rltnPoints: 0},
       {rspText: "Yes, I’m definitely saving up carefully.", moodPoints: 1, rltnPoints: 1}
     ]},

    {dialogNbr: 15, title: "Home Ownership",
     text: "You own your place, right? How do you like it?",
     conditionList: ["homeType-house"], type: "inPerson",
     responses: [
       {rspText: "Meh, it’s okay but could improve.", moodPoints: -1, rltnPoints: 0},
       {rspText: "I love it, feels really comfortable here.", moodPoints: 2, rltnPoints: 2}
     ]},

    {dialogNbr: 16, title: "Home as Investment",
     text: "Homes often rise in value over time. And each payment builds equity instead of paying rent.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Makes sense, I can see the benefit clearly.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Not really my thing, honestly.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 17, title: "BOGO Dinner",
     text: "Want to try a restaurant with me? I have a BOGO coupon. Could be fun and cheap!",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Let’s go, I love trying new food.", moodPoints: 2, rltnPoints: 2, cashAmt: -16.35},
       {rspText: "Maybe later, I’m busy tonight.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 18, title: "401k Adjust",
     text: "I’m cutting back on my 401(k) contributions so I can save cash for a down payment. Early withdrawals have fees.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Smart move, that really makes sense.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Sounds boring, not interested in that.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 19, title: "Promotion!",
     text: "I got promoted! A raise and a better bonus. Saving for a home just got easier.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Congrats! You really earned that promotion.", moodPoints: 1, rltnPoints: 2},
       {rspText: "Sounds like more work, be careful.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 20, title: "Used Furniture",
     text: "I bought gently used furniture from a consignment shop. Saved a ton and it looks great.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Nice find! It looks really great.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Used? No, I prefer brand new.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 21, title: "Hiking Invite",
     text: "Want to go hiking? It's free and good exercise.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "I’m in, I love outdoor activities.", moodPoints: 2, rltnPoints: 1},
       {rspText: "Not for me, I hate hiking.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 22, title: "Check-In",
     text: "Hey, just checking on you. How are you doing lately?",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Doing great, thanks for asking today!", moodPoints: 1, rltnPoints: 1},
       {rspText: "It’s tough, honestly feeling a bit overwhelmed.", moodPoints: -1, rltnPoints: 1}
     ]},

    {dialogNbr: 23, title: "Rates Rising",
     text: "The Fed may raise rates. If they do, mortgages will cost more. I'm starting my house search now.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Good timing, smart to start looking early.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Why rush, you can wait a bit.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 24, title: "Offer Rejected",
     text: "I found a great place, but my offer was beat. Disappointing… but maybe it wasn’t the right house.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "You’ll find one, don’t give up.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Bid higher next time, it’s simple.", moodPoints: -2, rltnPoints: -2}
     ]},

    {dialogNbr: 25, title: "Rate Math",
     text: "If a $350k home’s interest rate rises 1%, the monthly payment can jump $200+. Wild, right?",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Wow, that really escalates quickly indeed.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Doesn’t matter much to me anyway.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 26, title: "Starter Home Decision",
     text: "I found a house. It is smaller than I hoped, but the price is right. A starter home feels like the smart move.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Smart choice, a starter home makes sense.", moodPoints: 1, rltnPoints: 1},
       {rspText: "I’d pass and keep looking elsewhere.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 27, title: "New Home Found",
     text: "Good news! I decided to put a bid on that starter home. My offer was accepted. Want to see pictures?",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Yes, I would love to see them.", moodPoints: 1, rltnPoints: 2},
       {rspText: "Later, I’m a bit busy right now.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 28, title: "Moving Soon",
     text: "I close in a few weeks! I’m excited but nervous about the paperwork.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "You got this, you’ll handle everything fine.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Paperwork… ugh, that’s always so annoying.", moodPoints: 0, rltnPoints: 0}
     ]},

    {dialogNbr: 29, title: "Multiple Sclerosis",
     text: "A couple of years ago I was diagnosed with MS. It’s manageable, just affects my energy sometimes.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Thanks for sharing that with me today.", moodPoints: -1, rltnPoints: -1},
       {rspText: "Wow! That sounds a bit scary sometimes.", moodPoints: -1, rltnPoints: +2}
     ]},

    {dialogNbr: 30, title: "Infusion Help",
     text: "I have an infusion appointment soon. Would you mind sitting with me for a bit?",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Of course, I’ll sit with you gladly.", moodPoints: 2, rltnPoints: 2},
       {rspText: "Maybe next time, I’m not available now.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 31, title: "Coaching Mathletes",
     text: "I volunteer coaching mathletes. The kids are sharp! It's one of my favorite things.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "That’s great, they are lucky to have you.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Not my thing, I wouldn’t enjoy it.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 32, title: "Kids Struggle",
     text: "One kid in my mathletes group was really struggling with doing calculations quickly. But I've been working with him and he ended up doing really well in the last competition.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Good job, you really helped him succeed.", moodPoints: 2, rltnPoints: 2},
       {rspText: "Huh, I just use a calculator myself.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 33, title: "Moving Day",
     text: "I’m officially moved in! Boxes everywhere, but it feels good to have my own place.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Congrats, your new place looks amazing.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Messy! Hope you get it organized soon.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 34, title: "Starting Garden",
     text: "I’m planting a small garden—tomatoes, herbs, maybe cucumbers. Fresh food is cheap and fun.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Love that, fresh herbs are always the best.", moodPoints: 1, rltnPoints: 1},
       {rspText: "I hate vegetables, gardening isn’t my thing.", moodPoints: -1, rltnPoints: -2}
     ]},
         {dialogNbr: 35, title: "Garden Success",
     text: "My tomatoes exploded! I have way too many. Want some extras?",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Yes please, I love fresh tomatoes.", moodPoints: 1, rltnPoints: 2},
       {rspText: "I’m good, I don’t need extras.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 36, title: "Frugal Habit",
     text: "I track every dollar I spend for the month. It’s not glamorous, but it helps me stay grounded.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Smart habit, it really keeps you disciplined.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Too tedious, I don’t want to bother.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 37, title: "Little Splurges",
     text: "I try to save a lot, but I still budget for small treats. Balance matters.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Great idea, it keeps life enjoyable too.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Why bother, I don’t see the point.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 38, title: "Future Goals",
     text: "Long-term, I'd like to build a bigger garden and maybe foster a dog someday.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Love that, a dog and garden sound amazing.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Sounds like too much work to handle.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 39, title: "Home Update",
     text: "Mortgage payments feel real now, but it’s worth it. This place already feels like home.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Happy for you, it really seems cozy now.", moodPoints: 1, rltnPoints: 1},
       {rspText: "Too expensive, I wouldn’t enjoy that much.", moodPoints: -1, rltnPoints: -1}
     ]},

    {dialogNbr: 40, title: "Looking Ahead",
     text: "Thanks for being part of this journey with me. I’m excited to see what comes next for both of us.",
     conditionList: [], type: "inPerson",
     responses: [
       {rspText: "Me too! Can’t wait for the future.", moodPoints: 2, rltnPoints: 2},
       {rspText: "We’ll see, I’m cautiously optimistic about it.", moodPoints: -1, rltnPoints: -1}
     ]}

  ]
}

export default cindyGameDialogDataset;
